module.exports = __webpack_public_path__ + "assets/img/tit.542cd9d2.png";